import React from "react";
import { TickCircleIcon } from "../../../../helper/HwIcon";
import { HotelReviewComponent } from "../../list/components/HotelReview";
import { formatPrice, formatePriceFn } from "../../../../helper/commonFunction";
import { useSelector } from "react-redux";

export const HotelSummary = ({ data, roomLine, scrollToDiv, searchContext , rooms , name}) => {
  const { agentActiveCurrency,displayPrice } = useSelector((state) => state.userData);
  let amenities = data?.hotelInfo?.details?.amenities
  let roomName = Object.values(name)?.[0]?.[0]
  let cheapestPrice = roomName?.amount
  return (
    <div className="col-xl-4 col-lg-5 hw-hotel--singleList__hotelGalleryContent">
      <div className="hotel-content">
        <div className="hotel-content--block heading-wrap">
          <div className="hw-text20 hw-black mb-02 hw-fontBold" style={{textTransform:"capitalize"}}>
            {roomName?.rooomCategory ?? 'Semi Deluxe Room Free Wi-Fi'}
          </div>
          <div className="hw-black">{roomLine}</div>
        </div>
        <div className="hotel-content--block heading hw-incl--wrap">
          {
            amenities?.length > 0 ? amenities?.slice(0,5)?.map((a) => {
              return (
                <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                  <TickCircleIcon />
                  {a?.name}
                </div>
              )
            }) : <>
              <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <TickCircleIcon />
                Air conditioning
              </div>
              <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <TickCircleIcon />
                Free Wi-Fi
              </div>
              <div className="d-flex hw-gapy4 align-items-center hw-fontWeight--500 hw-icon--div">
                <TickCircleIcon />
                Room service
              </div>
            </>
          }
        </div>
        <div className="hotel-content--block heading hw-price--wrap">
          <div className="hw-text14">From:</div>
          <span className="hw-black hw-text22 hw-fontBold">
          {formatePriceFn(agentActiveCurrency , formatPrice(cheapestPrice,true,true), displayPrice)}
          </span>
          <span>&nbsp;{`${rooms} Room(s)`}</span>
          {/* <div className="hw-price--wrapHover">
            <div className="wrapHover-item">
              <span>Per Night for 2 Adults & 2 Children</span>
              <span className="hw-gray-900 hw-fontWeight--500">AED 560</span>
            </div>
            <div className="wrapHover-itemGroup">
              <div className="wrapHover-item">
                <span>Discount by the property</span>
                <span className="hw-gray-900 hw-fontWeight--500">- AED 80</span>
              </div>
              <div className="wrapHover-item">
                <span>
                  Deal Code <b className="cc-code">FRESHDEAL</b>
                </span>
                <span className="hw-gray-900 hw-fontWeight--500">- AED 20</span>
              </div>
            </div>
            <div className="wrapHover-item">
              <span>Total (Taxes Extra)</span>
              <span className="hw-gray-900 hw-fontWeight--500">AED 460</span>
            </div>
          </div> */}
        </div>
        <div className="hotel-content--block heading hw-button--wrap">
          <button
            className="hw-btn hw-btn--large hw-btn--primary w-100"
            onClick={() => {
              scrollToDiv("hotel_select_room");
            }}
          >
            {data?.hotelDetails?.hotels?.[0]?.options?.length} More Options
          </button>
        </div>
      </div>
      <div className="hotel-content">
        <div className="d-flex align-items-center justify-between hw-gapy10">
          <div className="hw-rating--tool">
            <HotelReviewComponent
              hotel={data?.hotelInfo}
              searchContext={searchContext}
              component={(label, avg, total) => {
                return (
                  <div className="d-flex align-items-center hw-gapy10">
                    <span className="hw-rating--value green-bg">{avg}/5</span>
                    <div className="d-flex align-items-center hw-gapy4">
                      <span className="hw-gray-900 hw-fontWeight--500">
                        {label}
                      </span>
                      <span className="hw-text12">({total} Ratings)</span>
                    </div>
                  </div>
                );
              }}
              searchCompleted={true}
            />
          </div>
          <div
            className="hw-bprimary--link"
            onClick={() => {
              scrollToDiv("hotel_guest_reviews");
            }}
          >
            All Reviews
          </div>
        </div>
      </div>
    </div>
  );
};